import { cachedIntlFormatter, useLocale } from '@capsicum/common';
import { Text } from '@capsicum/common-web';
import { useMemo } from 'react';

export const CurrencyAmountField = ({ amount, shortCode }: { amount?: string; shortCode: string }) => {
	const { locale } = useLocale();
	const numberAmount = Number(amount);

	const formattedAmount = useMemo(() => {
		// Format the number amount according to the locale
		const formatter = cachedIntlFormatter(locale, {
			maximumFractionDigits: 2,
			minimumFractionDigits: 2
		});

		return formatter.format(numberAmount);
	}, [locale, numberAmount]);

	if (isNaN(numberAmount)) {
		return <Text variant="text1">N/A</Text>;
	}

	return <Text variant="text1">{`${formattedAmount} ${shortCode}`}</Text>;
};
